import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

const Container = styled.div`
  font-family: Arial, Helvetica, sans-serif;
  max-width: 600px;
  margin: 20px auto;
  color: #333;
  padding: 0 16px;

  .description {
    margin-bottom: 10px;
    font-size: 14px;

    @media (max-width: ${screenSizes.tablet}) {
      font-size: 13px;
    }
  }

  .link-card {
    border: 1px solid #ddd;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f8f8fb;
    border-radius: 4px;
    margin-bottom: 12px;
    gap: 12px;

    @media (max-width: ${screenSizes.tablet}) {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      padding: 12px;
    }

    @media (max-width: ${screenSizes.mobile}) {
      padding: 10px;
    }
  }

  .file-info {
    flex: 1;
    min-width: 0;

    @media (max-width: ${screenSizes.tablet}) {
      width: 100%;
    }
  }

  .file-name {
    display: block;
    font-size: 14px;
    font-weight: bold;
    max-width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: ${screenSizes.tablet}) {
      max-width: 100%;
      font-size: 13px;
    }

    @media (max-width: ${screenSizes.mobile}) {
      font-size: 12px;
    }
  }

  .file-size {
    font-size: 12px;
    color: #666;

    @media (max-width: ${screenSizes.mobile}) {
      font-size: 11px;
    }
  }

  .download-button {
    background-color: #2f2f51;
    color: white;
    text-decoration: none;
    padding: 8px 16px;
    font-weight: bold;
    border-radius: 4px;
    font-size: 14px;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
      background-color: #1a1a35;
    }

    @media (max-width: ${screenSizes.tablet}) {
      width: 100%;
      text-align: center;
      padding: 10px 16px;
      font-size: 13px;
    }

    @media (max-width: ${screenSizes.mobile}) {
      padding: 8px 12px;
      font-size: 12px;
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    max-width: 100%;
    margin: 16px auto;
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 0 12px;
    margin: 12px auto;
  }
`;

const LinkContent = ({ description = '', link, textCTA = 'DESCARGAR' }) => {
  // Function to extract filename from URL
  const getFileName = (url) => {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;
      const filename = pathname.split('/').pop();
      return filename || 'Archivo';
    } catch (error) {
      // Fallback: try to extract filename from the string
      const parts = url.split('/');
      return parts[parts.length - 1] || 'Archivo';
    }
  };

  const fileName = getFileName(link);

  return (
    <Container>
      <p className="description">{description}</p>
      <div className="link-card">
        <div className="file-info">
          <strong className="file-name">{fileName}</strong>
        </div>
        <a className="download-button" href={link} target="_blank" rel="noopener noreferrer">
          {textCTA}
        </a>
      </div>
    </Container>
  );
};

export default LinkContent;
